export type Language = 'ja' | 'en';

export const translations = {
  ja: {
    common: {
      appName: 'Votica',
      tagline: '決選投票対応 汎用投票プラットフォーム',
      runoffBadge: '決選投票対応',
      createPoll: '投票を作成',
      newPoll: '+ 新規作成',
      admin: '管理者',
      creator: '作成者',
      anonymous: '匿名',
      guest: 'ゲスト',
      user: 'ユーザー',
      googleUser: 'Googleユーザー',
      demoUser: 'デモ参加者',
      cancel: 'キャンセル',
      save: '保存',
      close: '閉じる',
      delete: '削除',
      deletePoll: '投票を削除',
      confirmDelete: '削除する',
      deleting: '削除中...',
      copy: 'コピー',
      copied: 'コピー完了',
      share: '共有',
      vote: '投票する',
      viewResults: '結果を見る',
      detailsAndVote: '詳細・投票',
      backToHome: 'トップページへ戻る',
      backToVote: '投票ページへ戻る',
      loading: '読み込み中...',
      active: '進行中',
      closed: '終了',
      scheduled: '開始前',
      days: '日',
      hours: '時間',
      minutes: '分',
      seconds: '秒',
      notFoundTitle: '404',
      notFoundMessage: 'お探しのページは見つかりませんでした。',
    },
    header: {
      firebaseConnected: 'Firebase接続中 (設定を確認)',
      demoMode: 'ローカルデモ動作中 (Firebase設定)',
      googleSignedIn: 'Googleログイン済み',
      myDashboard: 'マイ投票ダッシュボード',
      createNewPoll: '新しい投票を作成',
      createPoll: '投票を作成',
      logout: 'ログアウト',
      signInWithGoogle: 'Googleでログイン',
      tryDemo: 'デモ体験',
      languageSwitch: '言語切替',
    },
    footer: {
      subtitle: '- 決選投票対応 汎用投票プラットフォーム',
      ossLicenses: 'OSSライセンス',
    },
    ossModal: {
      title: 'オープンソースソフトウェア (OSS) ライセンス',
      desc: 'このプロジェクトで使用されているオープンソースライブラリおよび著作権表記の一覧です。',
      searchPlaceholder: 'パッケージ名またはライセンスで検索...',
      tabAll: 'すべて ({{count}})',
      tabDependencies: 'プロダクション ({{count}})',
      tabDevDependencies: '開発用 ({{count}})',
      showLicense: 'ライセンス本文を表示',
      hideLicense: 'ライセンス本文を閉じる',
      copyLicense: 'ライセンス本文をコピー',
      copied: 'コピー完了',
      viewRepository: 'リポジトリ',
      viewNpm: 'npm',
      noResults: '該当するOSSパッケージが見つかりませんでした。',
      licenseType: 'ライセンス',
      copyright: '著作権',
    },
    home: {
      heroTitle: '意思決定を、もっと納得感のあるものに。少数意見も埋もれない、決選投票プラットフォーム。',
      heroSubtitle: 'Voticaは、選択肢が多いアンケートやチームの意思決定で同率1位が発生した際、自動で上位・同率候補による「決選投票」を開催できるスマート投票システムです。',
      joinPoll: '投票に参加:',
      pollIdPlaceholder: '共有された投票IDまたはURLを貼り付け (例: poll_abc123)',
      openPoll: '投票を開く',
      myPollsTab: '自分が作成した投票 ({{count}})',
      publicPollsTab: '公開中の投票 ({{count}})',
      noMyPollsTitle: '作成した投票はありません',
      noMyPollsDesc: 'チームの意思決定やアンケートのための投票フォームを数秒で作成できます。',
      createFirstPoll: '最初の投票を作成',
      noPublicPollsTitle: '現在公開中の投票はありません',
      noPublicPollsDesc: '新しい投票を作成して参加者を招待しましょう！',
      enterPollIdError: '投票IDまたはURLを入力してください',
      createScheduleCardTitle: '日程調整を作成',
      createScheduleCardDesc: '候補日時を設定し、参加者の出欠（◯・△・✕）をスピーディに集約・調整',
      createScheduleCardDescShort: '候補日を設定して出欠（◯・△・✕）をすばやく集約',
      createScheduleCardBadge: '出欠・イベント調整',
      createPollCardTitle: '投票を作成',
      createPollCardDesc: '選択肢（最大20個）を設定し、多数決や同率1位時の決選投票をスマートに実施',
      createPollCardDescShort: '選択肢を設定して多数決や決選投票を実施',
      createPollCardBadge: 'アンケート・意思決定',
    },
    create: {
      badge: '新規投票フォーム作成',
      title: '新しい投票を作成',
      subtitle: '選択肢（最大20件）、投票期間、上限選択数を設定して共有リンクを発行します。',
      loginRequiredTitle: 'Googleログインが必要です',
      loginRequiredDesc: '作成者として管理権限を保持するため、Googleアカウントでの認証が必要です。',
      loginButton: 'Googleでログイン',
      basicInfo: '基本情報',
      pollTitle: '投票タイトル',
      pollTitlePlaceholder: '例: 次回ハッカソンの開発テーマ決定投票',
      pollDesc: '説明・概要 (任意)',
      pollDescPlaceholder: '投票の趣旨や選定基準、補足情報などを記入してください',
      periodSettings: '投票期間の設定',
      startDate: '開始日時',
      endDate: '終了日時 (締め切り)',
      optionsSettings: '選択肢の設定',
      rulesSettings: '投票ルール & 結果公開設定',
      maxChoicesLabel: '1人あたりの選択上限数',
      singleChoiceDesc: '単一選択 (1つのみ)',
      multiChoicesDesc: '複数選択 (最大{{max}}つ)',
      singleChoiceOption: '1つだけ投票 (単一選択)',
      multiChoiceOption: '最大 {{count}}つまで投票',
      resultVisibility: '投票結果の閲覧権限',
      adminOnlyTitle: '管理者のみ閲覧可能 (デフォルト)',
      adminOnlyDesc: '作成者のみが集計結果を確認できます。後からいつでも全体公開に切り替え可能です。',
      publicResultTitle: '全員にリアルタイム公開',
      publicResultDesc: '投票した参加者全員がリアルタイムで途中結果と集計グラフを閲覧できます。',
      voterAuth: '投票者の認証設定',
      noLoginCheckbox: '投票にはログイン不要にする (自己申告のユーザー名で投票可能)',
      noLoginCheckboxDesc: 'チェックを入れると、参加者はGoogleログインしなくても自己申告のお名前を入力するだけで投票に参加できます。チェックなし（推奨）の場合は、Google認証により厳格な1人1票が保証されます。',
      voterNamesVisibility: '投票者内訳の表示設定 (誰がどれに投票したか)',
      showVoterNamesCheckbox: '結果ページで誰がどの選択肢に投票したか（投票者名）を表示する',
      showVoterNamesDesc: 'チェックなし（デフォルト・推奨）の場合は、得票数とグラフのみ表示され、個人の投票先は非公開（匿名投票）となります。チェックを入れると、結果ページで各選択肢に投票した人のお名前（記名投票）が表示されます。',
      dateOrderError: '終了日時は開始日時より未来に設定してください',
      footerNote: '作成後、同率1位が発生した場合は管理画面から決選投票を開始できます。',
      submitButton: '投票フォームを作成する',
      toastLoginReq: '投票を作成するにはGoogleログインが必要です',
      toastTitleReq: '投票タイトルを入力してください',
      toastOptionsReq: 'すべての選択肢に内容を入力してください',
      toastMinOptions: '選択肢は最低2つ必要です',
      toastMaxOptions: '選択肢の上限は20個までです',
      toastInvalidDates: '日時の指定が正しくありません',
      toastEndDateFuture: '終了日時は開始日時より未来に設定してください',
      toastSuccess: '投票フォームを作成しました！',
      toastFailed: '投票の作成に失敗しました: ',
      defaultRoundTitle: '第1回 投票',
      defaultRoundDesc: '初期投票ラウンド',
      defaultCreatorName: '管理者',
    },
    voting: {
      pollLoading: '投票データを読み込み中...',
      pollNotFound: '投票が見つかりませんでした',
      pollNotFoundDesc: '指定されたIDの投票が存在しないか、削除された可能性があります。',
      pollConcluded: '投票決着・終了 (全{{total}}回)',
      runoffInProgress: '第{{round}}回 決選投票進行中 (全{{total}}ラウンド)',
      round1: '第1回 投票',
      roundN: '第{{round}}回 投票',
      runoffFromRound: '第{{round}}回からの決選',
      noLoginAllowed: 'ログイン不要 (名前自己申告)',
      loginRequired: 'Googleログイン必須 (1人1票)',
      adminBadge: '管理者',
      shareBtn: '共有',
      adminResultsBtn: '管理・集計結果',
      resultsBtn: '集計結果',
      singleChoiceHint: '【単一選択】1つだけ選択',
      multiChoiceHint: '【複数選択】最大 {{max}} つまで選択可能',
      roundEndedRunoffActive: '第{{round}}回の投票は終了しました。現在、最新の決選投票（第{{current}}回）が進行中です。',
      goToCurrentRunoff: '第{{round}}回 決選投票へ移動',
      tieDetectedMsg: '投票期間が終了し、同率1位（{{names}}）が検出されました。',
      tieWaitAdmin: ' 管理者が決選投票を開始するまでお待ちください。',
      tieStartAdmin: ' 決選投票を開始してください。',
      startRunoffBtn: '決選投票を開始',
      winnerDetectedMsg: '投票期間が終了しました。第1位: 「{{name}}」({{votes}}票)',
      viewDetailResults: '詳細結果を見る',
      votingClosedBanner: 'このラウンドの投票受付は終了しました。',
      optionsTitle: '選択肢',
      totalOptionsCount: '全 {{count}} 件',
      selectedOptionsCount: '選択中: {{selected}} / {{max}} 件',
      loggedInAs: '{{name}} としてログイン中',
      votedInRound: 'このラウンドに投票済み ({{count}}件選択)',
      anonNameLabel: '投票者のお名前 (自己申告)',
      anonNamePlaceholder: '例: 田中 / ゲスト',
      anonVoted: '投票済み ({{count}}件選択)',
      googleLoginPrompt: '投票するにはGoogleログインが必要です (1人1票を保証)',
      statusClosed: '受付終了',
      statusScheduled: '開始前',
      btnUpdateVote: '投票内容を変更して再投票',
      btnSubmitVote: '投票を送信する',
      btnSignInAndVote: 'Googleでログインして投票',
      toastLoginRequired: '投票するにはGoogleログインが必要です',
      toastNameRequired: '投票者のお名前（自己申告）を入力してください',
      toastVotingClosed: 'この投票ラウンドの受付期間は終了しています',
      toastSelectOption: '投票する選択肢を1つ以上選んでください',
      toastMaxChoicesExceeded: '選択できるのは最大 {{max}} つまでです',
      toastVoteUpdated: '投票内容を更新しました！',
      toastVoteSuccess: '投票が完了しました！',
      toastVoteFailed: '投票の送信に失敗しました: ',
    },
    results: {
      loading: '集計結果を読み込み中...',
      privateTitle: '結果は非公開です',
      privateDesc: 'この投票の集計結果は管理者のみに限定されています。\n管理者が結果を公開すると、こちらで閲覧できるようになります。',
      adminPanel: '管理者コントロールパネル',
      publicResultsBtn: '結果公開中 (全体公開)',
      privateResultsBtn: '結果非公開 (管理者のみ)',
      voterNamesVisibleBtn: '投票者内訳: 表示中',
      voterNamesHiddenBtn: '投票者内訳: 非表示',
      startRunoffBtn: '決選投票を開始',
      currentRoundLabel: '現在のラウンド:',
      statusOpen: '受付中',
      statusClosed: '終了 / 締め切り済み',
      closeRoundEarly: 'このラウンドを早期終了する',
      reopenRound: '投票受付を再開する',
      reopenPoll: '投票全体を再開する',
      confirmCloseRound: 'このラウンドの投票受付を即時終了しますか？',
      resultsTitle: '第{{round}}回 集計結果',
      realtimeUpdate: '• リアルタイム更新',
      namedVotingBadge: '記名投票 (投票者内訳表示中)',
      anonymousVotingBadge: '匿名投票 (投票者内訳非表示)',
      toastPublicSuccess: '結果を全員に公開しました！',
      toastPrivateSuccess: '結果を非公開（管理者のみ）にしました',
      toastVoterNamesShown: '投票者内訳（記名投票）を「表示中」に切り替えました',
      toastVoterNamesHidden: '投票者内訳（匿名投票）を「非表示」に切り替えました',
      toastCloseSuccess: '投票受付を終了しました',
      toastReopenSuccess: '投票受付を再開しました',
      toastReopenPollSuccess: '投票を再開（進行中）に設定しました',
      toastUpdateFailed: '設定の更新に失敗しました: ',
    },
    chart: {
      totalVoters: '総投票者数',
      votersUnit: '人',
      totalVotes: '総票数',
      votesUnit: '票',
      maxVotes: '最多得票数',
      votersBreakdown: '投票者 ({{count}}名):',
    },
    resultChart: {
      totalVoters: '総投票者数',
      votersUnit: '人',
      totalVotes: '総票数',
      votesUnit: '票',
      maxVotes: '最多得票数',
      votersList: '投票者 ({{count}}名):',
      votersBreakdown: '投票者 ({{count}}名):',
    },
    winnerBadge: {
      tieDetected: '同率1位検出',
      tieVotes: '({{votes}}票獲得)',
      tieMessage: '{{names}} が同率1位です！',
      tieDesc: '決着をつけるために、同率候補のみでの決選投票を実施することができます。',
      startRunoffBtn: '決選投票を開始',
      winnerConfirmed: '第1位 確定',
      firstPlaceWinner: '第1位 確定',
      provisionalFirstPlace: '暫定1位',
      winnerVotes: '{{votes}} 票 ({{percentage}}%)',
    },
    runoffModal: {
      title: '第{{round}}回 決選投票の作成',
      desc: '前回の投票結果を引き継ぎ、新しい決選投票ラウンドを開始します',
      modalTitle: '第{{round}}回 決選投票の作成',
      modalDesc: '前回の投票結果を引き継ぎ、新しい決選投票ラウンドを開始します',
      candidateMethodLabel: '決選投票の候補抽出方法',
      methodLabel: '決選投票の候補抽出方法',
      recommendedBadge: '推奨',
      tiedOnlyTitle: '同率1位のみ',
      tiedOnlyDesc: '{{count}}件の同率候補',
      tiedCandidatesDesc: '{{count}}件の同率候補',
      top2Title: 'TOP 2 決選',
      top2Badge: '上位2件',
      top2Desc: '上位2候補に絞り込み',
      topKTitle: 'TOP {{k}} 決選',
      topKBadge: '上位{{k}}件',
      topKDesc: '上位{{k}}候補に絞り込み',
      customTitle: 'カスタム選択',
      customBadge: '自由選択',
      customDesc: '候補を手動でチェック',
      selectedCandidatesLabel: '決選投票に含まれる候補 ({{count}}件選択中)',
      candidatesLabel: '決選投票に含まれる候補 ({{count}}件選択中)',
      clickToToggle: 'クリックして追加/除外',
      previousStats: '前回: {{votes}}票 ({{rank}}位)',
      prevResult: '前回: {{votes}}票 ({{rank}}位)',
      roundTitleLabel: '決選投票のタイトル',
      titleLabel: '決選投票のタイトル',
      defaultTitleTied: '第{{round}}回 決選投票 (同率1位)',
      defaultTitleTie: '第{{round}}回 決選投票 (同率1位)',
      defaultTitleTopK: '第{{round}}回 決選投票 (上位{{k}}件)',
      defaultTitleGeneral: '第{{round}}回 決選投票',
      defaultDescTied: '前回の投票で同率1位となった候補による決選投票です。再度1人1票を投票してください。',
      defaultDescTie: '前回の投票で同率1位となった候補による決選投票です。再度1人1票を投票してください。',
      defaultDescTopK: '上位候補による決選投票です。再度1人1票を投票してください。',
      defaultDescGeneral: '上位候補による決選投票です。再度1人1票を投票してください。',
      startDateLabel: '開始日時',
      endDateLabel: '終了日時',
      maxChoicesLabel: '1人あたりの選択可能上限数',
      singleChoiceOption: '1つだけ選択 (単一投票 - 決選推奨)',
      maxChoicesOption: '最大 {{count}}つまで選択',
      startRunoffSubmit: '第{{round}}回 決選投票を開始',
      submitRunoffBtn: '第{{round}}回 決選投票を開始',
      toastMinCandidates: '決選投票には最低2つの候補が必要です',
      toastMinCandidatesWarning: '決選投票には最低2つの選択肢が必要です',
      toastMinOptionsWarn: '決選投票には最低2つの選択肢が必要です',
      toastInvalidDates: '終了日時は開始日時より未来に設定してください',
      toastSuccess: '第{{round}}回 決選投票を開始しました！',
      toastFailed: '決選投票の作成に失敗しました: ',
      toastError: '決選投票の作成に失敗しました: ',
    },
    share: {
      title: '投票リンクを共有',
      desc: 'URLまたはQRコードを共有して、参加者に投票を呼びかけましょう',
      pollUrlLabel: '投票ページ URL',
      copy: 'コピー',
      copied: 'コピー完了',
      shareOnX: 'で共有',
      shareOnLine: 'LINE で送る',
      toastCopied: 'URLをクリップボードにコピーしました！',
    },
    shareModal: {
      title: '投票リンクを共有',
      desc: 'URLまたはQRコードを共有して、参加者に投票を呼びかけましょう',
      urlLabel: '投票ページ URL',
      copyBtn: 'コピー',
      copiedBtn: 'コピー完了',
      shareX: 'で共有',
      shareLine: 'LINE で送る',
      toastCopied: 'URLをクリップボードにコピーしました！',
      tweetText: '【投票のお願い】「{{title}}」に投票しよう！ #Votica\n',
    },
    optionInput: {
      title: '投票の選択肢',
      countLabel: '{{count}} / {{max}} 件 (2〜20件)',
      placeholder: '選択肢 {{index}} (例: 選択肢の内容)',
      moveUp: '上へ移動',
      moveDown: '下へ移動',
      minRequired: '選択肢は最低2つ必要です',
      remove: '選択肢を削除',
      addOption: '選択肢を追加 (あと {{remaining}} 件)',
    },
    timer: {
      ended: '投票期間終了 (締め切り済み)',
      startsIn: '開始まであと:',
      openRemaining: '投票受付中 (残り:',
      days: '日 ',
    },
    roundSelector: {
      label: 'ラウンド切替:',
      roundN: '第{{round}}ラウンド',
      roundTitle: '第{{round}}ラウンド',
      activeBadge: '進行中',
    },
    firebaseModal: {
      title: 'Firebase 接続設定',
      desc: 'Google認証およびFirestoreデータベースの接続先を設定します',
      connected: 'Firebaseに接続中',
      demoMode: 'ローカルデモ動作中',
      statusConnected: 'Firebaseに接続中',
      statusLocalDemo: 'ローカルデモモードで動作中',
      statusConnectedDesc: 'Google認証とFirestoreが有効です。',
      statusLocalDemoDesc: '設定が未入力の場合でも、ブラウザローカル保存機能で全機能を体験可能です。',
      connectedDesc: 'Google認証とFirestoreが有効です。',
      demoDesc: '設定が未入力の場合でも、ブラウザローカル保存機能で全機能を体験可能です。',
      jsonPasteLabel: 'Firebaseコンソールの設定オブジェクトを貼り付け (任意)',
      quickPasteLabel: 'Firebaseコンソールの設定オブジェクトを貼り付け (任意)',
      apiKeyLabel: 'API Key (apiKey) *',
      projectIdLabel: 'Project ID (projectId) *',
      authDomainLabel: 'Auth Domain (authDomain)',
      appIdLabel: 'App ID (appId)',
      resetBtn: '設定をリセット',
      resetConfigBtn: '設定をリセット',
      localSavedNotice: 'ブラウザ内にのみ安全に保存されます',
      localStorageNote: 'ブラウザ内にのみ安全に保存されます',
      saveAndApplyBtn: '保存して適用',
      saveApplyBtn: '保存して適用',
      toastJsonLoaded: 'Firebase設定JSONを読み込みました',
      toastReqFields: 'APIキーとプロジェクトIDは必須です',
      toastRequiredFields: 'APIキーとプロジェクトIDは必須です',
      toastSaved: 'Firebase設定を保存しました。ページを再読み込みします',
      confirmClear: '保存されているFirebase設定をクリアして、ローカルデモモードに戻しますか？',
      confirmReset: '保存されているFirebase設定をクリアして、ローカルデモモードに戻しますか？',
      toastCleared: 'Firebase設定をクリアしました',
    },
    deleteModal: {
      title: '投票を完全に削除しますか？',
      desc: '投票「{{title}}」とそれに紐づくすべてのラウンド、選択肢、投票データが完全に削除されます。この操作は取り消せません。',
      confirmBtn: '完全に削除する',
      cancelBtn: 'キャンセル',
      toastSuccess: '投票を削除しました',
      toastFailed: '投票の削除に失敗しました: ',
      notAuthorized: '投票を削除する権限がありません',
    },
    schedule: {
      badge: '日程調整',
      createBadge: '新規日程調整作成',
      createTitle: '新しい日程調整を作成',
      createSubtitle: 'イベント名と候補日程を入力して出欠表を作成・共有します。回答者はログイン不要で参加可能です。',
      tabStandardPoll: '通常の投票',
      tabScheduleAdjust: '日程調整',
      createHeaderBtn: '日程調整',
      homeCreateBtn: '日程調整を作成',
      createNewSchedule: '新しい日程調整を作成',
      eventInfoTitle: 'イベント情報',
      eventTitleLabel: 'イベント名',
      eventTitlePlaceholder: '例: 3月度 定例ミーティング / 歓送迎会',
      eventDescLabel: '説明・メモ (場所、予算、オンラインURLなど)',
      eventDescPlaceholder: '場所や予算、詳細、参加者への連絡事項などを入力してください',
      candidateDatesTitle: '候補日程の設定',
      candidateCount: '候補日: {{count}}件',
      candidateTextareaLabel: '候補日程の入力 (1行に1つの日程)',
      candidateTextareaPlaceholder: '8/25(月) 19:00〜\n8/26(火) 19:00〜\n8/27(水) 20:00〜',
      candidateTextareaHint: '※ カレンダー・クイック追加ツールからも簡単に追加できます（最大30件）',
      quickAddTitle: 'カレンダー & クイック日程追加',
      quickAddHelp: 'クリックで候補日を自動追加',
      addCandidateBtn: '候補日を追加',
      presetLabel: 'クイック追加',
      preset3Days: '直近3日間',
      preset7Days: '直近7日間',
      presetWeekend: '今週末 (土日)',
      presetNextWeekdays: '来週平日 (月〜金)',
      settingsTitle: '詳細設定 (期限・公開設定)',
      showAdvanced: '詳細設定を表示',
      hideAdvanced: '詳細設定を閉じる',
      noLoginDesc: 'チェックを入れると、参加者はGoogleログインなしでお名前を入力するだけで出欠を回答できます。',
      showAttendanceNamesCheckbox: '出欠表に参加者のお名前と回答（◯△✗）を公開する',
      showAttendanceNamesDesc: '参加者全員が互いの出欠状況を確認できます（日程調整では推奨）。',
      publicAttendanceTitle: '参加者全員に出欠表を公開',
      publicAttendanceDesc: 'URLを知っている全員が出欠表と集計結果をリアルタイムで閲覧できます。',
      footerNote: '作成後、発行されたURLをLINEやメール、Slack等で参加者に共有してください。',
      submitBtn: '日程調整を作成して共有リンクを発行',
      toastTitleReq: 'イベント名を入力してください',
      toastMinCandidates: '候補日程を1件以上入力してください',
      toastMaxCandidates: '候補日程は最大30件までです',
      toastSuccess: '日程調整イベントを作成しました！',
      defaultRoundTitle: '出欠回答',
      scheduleHeaderBadge: '日程調整・出欠確認',
      choicesGuide: '各候補日ごとに ◯ (参加) / △ (未定) / ✗ (不参加) を選択',
      votingSectionTitle: '出欠を回答する',
      batchSelectLabel: '一括選択',
      allCircle: 'すべて◯',
      allTriangle: 'すべて△',
      allCross: 'すべて✗',
      commentLabel: '一言コメント',
      optional: '任意',
      commentPlaceholder: '例: 遅れて参加します / 20時以降ならOK',
      alreadyResponded: '回答済み (変更可能)',
      btnSubmitResponse: '出欠を送信する',
      btnUpdateResponse: '回答内容を更新する',
      toastSelectAttendance: '候補日の出欠を1つ以上選択してください',
      resultsTitle: '出欠集計結果',
      attendanceTableTitle: '参加者出欠表',
      votersCount: '回答者: {{count}}名',
      copyTextBtn: '出欠テキストをコピー',
      downloadCsvBtn: 'CSVダウンロード',
      toastTextCopied: '出欠まとめテキストをクリップボードにコピーしました！',
      toastCsvDownloaded: 'CSVファイルをダウンロードしました！',
      bestCandidateLabel: '👑 最も参加者が多いおすすめ候補日',
      bestCandidateDesc: '参加可能 (◯): {{circles}}名 / 全{{total}}名',
      candidateDateCol: '候補日時',
      scoreCol: 'スコア',
      tallyCol: '◯ / △ / ✗',
      commentsRow: '一言コメント',
      noVotesYetTitle: 'まだ回答がありません',
      noVotesYetDesc: '共有URLを参加者に送って出欠を回答してもらいましょう！',
    },
    theme: {
      sectionTitle: 'ページデザインテーマ',
      sectionDesc: 'イベントや用途に合わせて20種類以上のデザインから選べます（デフォルト: クラシック・インディゴ）',
      previewTitle: '選択中テーマのプレビュー',
      selectedBadge: '選択中',
      catAll: 'すべて',
      catSimple: 'シンプル',
      catBusiness: 'ビジネス',
      catCool: 'クール＆ダーク',
      catCute: 'かわいい＆ポップ',
      catNatural: 'ナチュラル＆和風',
      default: {
        name: 'クラシック・インディゴ',
        desc: '知性と思慮深さを感じさせる洗練された標準デザイン',
      },
      minimalSlate: {
        name: 'ミニマル・スレート',
        desc: '白黒と無彩色グレーで整えた極限のミニマリズム',
      },
      nordicFrost: {
        name: '北欧フロスト',
        desc: '澄んだアイスブルーと冷涼な空気を感じる北欧デザイン',
      },
      warmLatte: {
        name: 'ウォーム・ラテ',
        desc: '優しいミルクティーとサンドベージュの穏やかなトーン',
      },
      corporateNavy: {
        name: 'コーポレート・ネイビー',
        desc: '高い信頼と誠実さを醸し出す濃紺のビジネススタイル',
      },
      executiveEmerald: {
        name: 'エグゼクティブ・エメラルド',
        desc: '深みのあるエメラルドグリーンと上品な佇まい',
      },
      steelGraphite: {
        name: 'スチール・グラファイト',
        desc: '鋼のように堅牢でクールなグレーと論理的なスタイル',
      },
      bordeauxWine: {
        name: 'ボルドー・ワイン',
        desc: '格式高い深紅ワインと上品なバーガンディのフォーマル感',
      },
      midnightBlack: {
        name: 'ミッドナイト・ダーク',
        desc: '漆黒の夜空とクールなブルーのシックなダークモード',
      },
      cyberNeon: {
        name: 'サイバー・ネオン',
        desc: '暗闇に光るネオンシアンとマゼンタのサイバーパンク感',
      },
      deepSpace: {
        name: 'ディープ・スペース',
        desc: '宇宙の深淵を思わせるダークバイオレットと神秘的な紫',
      },
      sunsetGlow: {
        name: 'サンセット・グロー',
        desc: '夕暮れのエネルギッシュなオレンジと情熱的なグラデーション',
      },
      sakuraPink: {
        name: 'さくらピンク',
        desc: '桜の花びらのようにふんわり華やかで優しいソフトピンク',
      },
      pastelCandy: {
        name: 'パステル・キャンディ',
        desc: 'パステルラベンダーとスカイブルーのゆめかわいいポップ調',
      },
      sunnyCitrus: {
        name: 'サニー・シトラス',
        desc: '元気いっぱいのビタミンイエローと明るい太陽の光',
      },
      freshMint: {
        name: 'フレッシュ・ミント',
        desc: '爽快で愛らしいミントグリーンと爽やかな清涼感',
      },
      berrySmoothie: {
        name: 'ベリー・スムージー',
        desc: '甘酸っぱいラズベリーとストロベリーのキュートな色彩',
      },
      forestGreen: {
        name: 'フォレスト・グリーン',
        desc: '深い森の木々と大地を感じさせるアースカラー',
      },
      matchaGreen: {
        name: '和風・抹茶',
        desc: '侘び寂びを感じる上品な抹茶色と生成りの和モダン',
      },
      coffeeMocha: {
        name: 'カフェ・モカ',
        desc: '淹れたての珈琲とキャラメルの温もりあるカフェスタイル',
      },
      retroPop: {
        name: 'レトロ・ポップ',
        desc: '70-80年代風のヴィンテージマスタード＆テラコッタ',
      },
      lavenderGarden: {
        name: 'ラベンダー・ガーデン',
        desc: '心やすらぐハーブの香りと優しいラベンダーパープル',
      },
    },
  },
  en: {
    common: {
      appName: 'Votica',
      tagline: 'Versatile Voting Platform with Runoff Support',
      runoffBadge: 'Runoff Ready',
      createPoll: 'Create Poll',
      newPoll: '+ New Poll',
      admin: 'Admin',
      creator: 'Creator',
      anonymous: 'Anonymous',
      guest: 'Guest',
      user: 'User',
      googleUser: 'Google User',
      demoUser: 'Demo User',
      cancel: 'Cancel',
      save: 'Save',
      close: 'Close',
      delete: 'Delete',
      deletePoll: 'Delete Poll',
      confirmDelete: 'Delete',
      deleting: 'Deleting...',
      copy: 'Copy',
      copied: 'Copied!',
      share: 'Share',
      vote: 'Vote',
      viewResults: 'View Results',
      detailsAndVote: 'Details & Vote',
      backToHome: 'Back to Home',
      backToVote: 'Back to Voting Page',
      loading: 'Loading...',
      active: 'Active',
      closed: 'Closed',
      scheduled: 'Scheduled',
      days: 'd',
      hours: 'h',
      minutes: 'm',
      seconds: 's',
      notFoundTitle: '404',
      notFoundMessage: 'The page you are looking for could not be found.',
    },
    header: {
      firebaseConnected: 'Connected to Firebase (View settings)',
      demoMode: 'Running in Local Demo (Firebase settings)',
      googleSignedIn: 'Signed in with Google',
      myDashboard: 'My Polls Dashboard',
      createNewPoll: 'Create New Poll',
      createPoll: 'Create Poll',
      logout: 'Log out',
      signInWithGoogle: 'Sign in with Google',
      tryDemo: 'Demo Mode',
      languageSwitch: 'Language',
    },
    footer: {
      subtitle: '- Versatile Voting Platform with Runoff Support',
      ossLicenses: 'OSS Licenses',
    },
    ossModal: {
      title: 'Open Source Software (OSS) Licenses',
      desc: 'List of open-source software libraries, licenses, and copyright notices used in this project.',
      searchPlaceholder: 'Search by package name or license...',
      tabAll: 'All ({{count}})',
      tabDependencies: 'Production ({{count}})',
      tabDevDependencies: 'Dev Dependencies ({{count}})',
      showLicense: 'Show license text',
      hideLicense: 'Hide license text',
      copyLicense: 'Copy license text',
      copied: 'Copied!',
      viewRepository: 'Repository',
      viewNpm: 'npm',
      noResults: 'No matching OSS packages found.',
      licenseType: 'License',
      copyright: 'Copyright',
    },
    home: {
      heroTitle: 'Making Decisions Confident & Fair Decisions with Smart Runoffs.',
      heroSubtitle: 'Votica is a smart voting system that automatically hosts instant runoff rounds for tied or top candidates, ensuring minority voices are counted.',
      joinPoll: 'Join a Poll:',
      pollIdPlaceholder: 'Paste shared Poll ID or URL (e.g. poll_abc123)',
      openPoll: 'Open Poll',
      myPollsTab: 'My Polls ({{count}})',
      publicPollsTab: 'Public Polls ({{count}})',
      noMyPollsTitle: 'No polls created yet',
      noMyPollsDesc: 'Create a poll for team decision-making and surveys in seconds.',
      createFirstPoll: 'Create First Poll',
      noPublicPollsTitle: 'No public polls available',
      noPublicPollsDesc: 'Create a new poll and invite participants!',
      enterPollIdError: 'Please enter a Poll ID or URL',
      createScheduleCardTitle: 'Create Schedule',
      createScheduleCardDesc: 'Set candidate dates & times to quickly collect availability (✓ / ? / ✕)',
      createScheduleCardDescShort: 'Set candidate dates to collect availability (✓ / ✕)',
      createScheduleCardBadge: 'Availability & Event Planning',
      createPollCardTitle: 'Create Poll',
      createPollCardDesc: 'Set options (up to 20) with single/multi choices & automatic runoff support',
      createPollCardDescShort: 'Multi-choice voting with instant runoff support',
      createPollCardBadge: 'Survey & Decision Making',
    },
    create: {
      badge: 'Create New Poll Form',
      title: 'Create a New Poll',
      subtitle: 'Set up options (up to 20), voting period, and max choices to generate a shareable link.',
      loginRequiredTitle: 'Google Sign-in Required',
      loginRequiredDesc: 'Authentication with a Google account is required to retain creator admin privileges.',
      loginButton: 'Sign in with Google',
      basicInfo: 'Basic Information',
      pollTitle: 'Poll Title',
      pollTitlePlaceholder: 'e.g. Next Hackathon Theme Selection',
      pollDesc: 'Description / Overview (Optional)',
      pollDescPlaceholder: 'Enter the purpose of the poll, selection criteria, or background notes',
      periodSettings: 'Voting Period',
      startDate: 'Start Date & Time',
      endDate: 'End Date & Time (Deadline)',
      optionsSettings: 'Options',
      rulesSettings: 'Voting Rules & Result Visibility',
      maxChoicesLabel: 'Maximum Choices per Voter',
      singleChoiceDesc: 'Single choice (1 only)',
      multiChoicesDesc: 'Multiple choices (up to {{max}})',
      singleChoiceOption: 'Vote for 1 option (Single choice)',
      multiChoiceOption: 'Vote for up to {{count}} options',
      resultVisibility: 'Result Visibility',
      adminOnlyTitle: 'Admin Only (Default)',
      adminOnlyDesc: 'Only the creator can view results. You can make it public at any time later.',
      publicResultTitle: 'Public to Everyone in Real-Time',
      publicResultDesc: 'All participants can view live results and charts in real time.',
      voterAuth: 'Voter Authentication',
      noLoginCheckbox: 'No login required to vote (Voters enter self-declared nickname)',
      noLoginCheckboxDesc: 'When checked, participants can vote without Google sign-in by entering their nickname. When unchecked (recommended), Google authentication strictly guarantees 1 vote per person.',
      voterNamesVisibility: 'Voter Breakdown Visibility (Who voted for what)',
      showVoterNamesCheckbox: 'Show voter names per option on the results page',
      showVoterNamesDesc: 'When unchecked (default/recommended), individual choices remain private (anonymous voting). When checked, voter names are displayed next to their selected options (named voting).',
      dateOrderError: 'End time must be after the start time',
      footerNote: 'If a 1st place tie occurs, you can launch a runoff round from the admin panel.',
      submitButton: 'Create Poll',
      toastLoginReq: 'Google sign-in is required to create a poll',
      toastTitleReq: 'Please enter a poll title',
      toastOptionsReq: 'Please fill in all options',
      toastMinOptions: 'At least 2 options are required',
      toastMaxOptions: 'Maximum of 20 options allowed',
      toastInvalidDates: 'Invalid date/time range',
      toastEndDateFuture: 'End time must be after the start time',
      toastSuccess: 'Poll created successfully!',
      toastFailed: 'Failed to create poll: ',
      defaultRoundTitle: 'Round 1 Voting',
      defaultRoundDesc: 'Initial voting round',
      defaultCreatorName: 'Admin',
    },
    voting: {
      pollLoading: 'Loading poll data...',
      pollNotFound: 'Poll Not Found',
      pollNotFoundDesc: 'The specified poll does not exist or may have been deleted.',
      pollConcluded: 'Poll Concluded ({{total}} rounds total)',
      runoffInProgress: 'Round {{round}} Runoff in Progress ({{total}} rounds total)',
      round1: 'Round 1 Voting',
      roundN: 'Round {{round}} Voting',
      runoffFromRound: 'Runoff from Round {{round}}',
      noLoginAllowed: 'No Login Required (Self-declared name)',
      loginRequired: 'Google Login Required (1 vote per person)',
      adminBadge: 'Admin',
      shareBtn: 'Share',
      adminResultsBtn: 'Admin & Results',
      resultsBtn: 'Results',
      singleChoiceHint: '[Single Choice] Select 1 option',
      multiChoiceHint: '[Multiple Choice] Select up to {{max}} options',
      roundEndedRunoffActive: 'Round {{round}} voting has ended. The latest runoff (Round {{current}}) is now in progress.',
      goToCurrentRunoff: 'Go to Round {{round}} Runoff',
      tieDetectedMsg: 'Voting has ended, and a tie for 1st place was detected ({{names}}).',
      tieWaitAdmin: ' Please wait for the admin to initiate a runoff.',
      tieStartAdmin: ' Please start a runoff round.',
      startRunoffBtn: 'Start Runoff Round',
      winnerDetectedMsg: 'Voting ended. 1st Place: "{{name}}" ({{votes}} votes)',
      viewDetailResults: 'View Detailed Results',
      votingClosedBanner: 'Voting for this round is now closed.',
      optionsTitle: 'Options',
      totalOptionsCount: 'Total: {{count}}',
      selectedOptionsCount: 'Selected: {{selected}} / {{max}}',
      loggedInAs: 'Logged in as {{name}}',
      votedInRound: 'Voted in this round ({{count}} selected)',
      anonNameLabel: 'Your Name (Self-declared nickname)',
      anonNamePlaceholder: 'e.g. Alex / Guest',
      anonVoted: 'Voted ({{count}} selected)',
      googleLoginPrompt: 'Google sign-in required to vote (guarantees 1 vote per person)',
      statusClosed: 'Closed',
      statusScheduled: 'Upcoming',
      btnUpdateVote: 'Update My Vote',
      btnSubmitVote: 'Submit Vote',
      btnSignInAndVote: 'Sign in with Google to Vote',
      toastLoginRequired: 'Google sign-in is required to vote',
      toastNameRequired: 'Please enter your name/nickname',
      toastVotingClosed: 'Voting period for this round has ended',
      toastSelectOption: 'Please select at least 1 option',
      toastMaxChoicesExceeded: 'You can select up to {{max}} options',
      toastVoteUpdated: 'Vote updated successfully!',
      toastVoteSuccess: 'Vote submitted successfully!',
      toastVoteFailed: 'Failed to submit vote: ',
    },
    results: {
      loading: 'Loading results...',
      privateTitle: 'Results are Private',
      privateDesc: 'Results for this poll are restricted to the administrator.\nThey will become visible here once the admin makes them public.',
      adminPanel: 'Admin Control Panel',
      publicResultsBtn: 'Results: Public (Everyone)',
      privateResultsBtn: 'Results: Private (Admin only)',
      voterNamesVisibleBtn: 'Voter Breakdown: Visible',
      voterNamesHiddenBtn: 'Voter Breakdown: Hidden',
      startRunoffBtn: 'Start Runoff Round',
      currentRoundLabel: 'Current Round:',
      statusOpen: 'Active',
      statusClosed: 'Closed / Ended',
      closeRoundEarly: 'End this round early',
      reopenRound: 'Reopen voting',
      reopenPoll: 'Reopen entire poll',
      confirmCloseRound: 'Are you sure you want to close voting for this round immediately?',
      resultsTitle: 'Round {{round}} Results',
      realtimeUpdate: '• Live updates',
      namedVotingBadge: 'Named Voting (Voter names visible)',
      anonymousVotingBadge: 'Anonymous Voting (Voter names hidden)',
      toastPublicSuccess: 'Results are now public to everyone!',
      toastPrivateSuccess: 'Results are now private (admin only)',
      toastVoterNamesShown: 'Voter breakdown (named voting) is now visible',
      toastVoterNamesHidden: 'Voter breakdown (anonymous voting) is now hidden',
      toastCloseSuccess: 'Voting closed',
      toastReopenSuccess: 'Voting reopened',
      toastReopenPollSuccess: 'Poll set to active',
      toastUpdateFailed: 'Failed to update settings: ',
    },
    chart: {
      totalVoters: 'Total Voters',
      votersUnit: ' voters',
      totalVotes: 'Total Votes',
      votesUnit: ' votes',
      maxVotes: 'Highest Votes',
      votersBreakdown: 'Voters ({{count}}):',
    },
    resultChart: {
      totalVoters: 'Total Voters',
      votersUnit: ' voters',
      totalVotes: 'Total Votes',
      votesUnit: ' votes',
      maxVotes: 'Highest Votes',
      votersList: 'Voters ({{count}}):',
      votersBreakdown: 'Voters ({{count}}):',
    },
    winnerBadge: {
      tieDetected: 'Tie for 1st Place Detected',
      tieVotes: '({{votes}} votes)',
      tieMessage: '{{names}} are tied for 1st place!',
      tieDesc: 'To determine a final winner, a runoff round can be conducted with only the tied candidates.',
      startRunoffBtn: 'Start Runoff Round',
      winnerConfirmed: '1st Place Winner Confirmed',
      firstPlaceWinner: '1st Place Winner Confirmed',
      provisionalFirstPlace: 'Provisional 1st Place',
      winnerVotes: '{{votes}} votes ({{percentage}}%)',
    },
    runoffModal: {
      title: 'Create Round {{round}} Runoff',
      desc: 'Carry forward results and launch a new runoff round',
      modalTitle: 'Create Round {{round}} Runoff',
      modalDesc: 'Carry forward results and launch a new runoff round',
      candidateMethodLabel: 'Candidate Extraction Method',
      methodLabel: 'Candidate Extraction Method',
      recommendedBadge: 'Recommended',
      tiedOnlyTitle: 'Tied 1st Only',
      tiedOnlyDesc: '{{count}} tied candidate(s)',
      tiedCandidatesDesc: '{{count}} tied candidate(s)',
      top2Title: 'TOP 2 Runoff',
      top2Badge: 'Top 2',
      top2Desc: 'Narrow down to top 2 candidates',
      topKTitle: 'TOP {{k}} Runoff',
      topKBadge: 'Top {{k}}',
      topKDesc: 'Narrow down to top {{k}} candidates',
      customTitle: 'Custom Selection',
      customBadge: 'Custom',
      customDesc: 'Manually choose candidates',
      selectedCandidatesLabel: 'Candidates included in runoff ({{count}} selected)',
      candidatesLabel: 'Candidates included in runoff ({{count}} selected)',
      clickToToggle: 'Click to include / exclude',
      previousStats: 'Prev: {{votes}} votes (Rank #{{rank}})',
      prevResult: 'Prev: {{votes}} votes (Rank #{{rank}})',
      roundTitleLabel: 'Runoff Poll Title',
      titleLabel: 'Runoff Poll Title',
      defaultTitleTied: 'Round {{round}} Runoff (Tied 1st)',
      defaultTitleTie: 'Round {{round}} Runoff (Tied 1st)',
      defaultTitleTopK: 'Round {{round}} Runoff (Top {{k}})',
      defaultTitleGeneral: 'Round {{round}} Runoff',
      defaultDescTied: 'Runoff between candidates who tied for 1st place. Please cast your vote.',
      defaultDescTie: 'Runoff between candidates who tied for 1st place. Please cast your vote.',
      defaultDescTopK: 'Runoff between top candidates. Please cast your vote.',
      defaultDescGeneral: 'Runoff between top candidates. Please cast your vote.',
      startDateLabel: 'Start Date & Time',
      endDateLabel: 'End Date & Time',
      maxChoicesLabel: 'Maximum Choices per Voter',
      singleChoiceOption: 'Select 1 only (Single choice - recommended)',
      maxChoicesOption: 'Select up to {{count}} options',
      startRunoffSubmit: 'Start Round {{round}} Runoff',
      submitRunoffBtn: 'Start Round {{round}} Runoff',
      toastMinCandidates: 'At least 2 candidates are required for a runoff',
      toastMinCandidatesWarning: 'At least 2 options are required for a runoff',
      toastMinOptionsWarn: 'At least 2 options are required for a runoff',
      toastInvalidDates: 'End time must be after the start time',
      toastSuccess: 'Round {{round}} Runoff started!',
      toastFailed: 'Failed to create runoff: ',
      toastError: 'Failed to create runoff: ',
    },
    share: {
      title: 'Share Poll Link',
      desc: 'Share the link or QR code to invite participants to vote',
      pollUrlLabel: 'Poll Page URL',
      copy: 'Copy',
      copied: 'Copied!',
      shareOnX: 'Share on',
      shareLine: 'Send via LINE',
      toastCopied: 'URL copied to clipboard!',
    },
    shareModal: {
      title: 'Share Poll Link',
      desc: 'Share the link or QR code to invite participants to vote',
      urlLabel: 'Poll Page URL',
      copyBtn: 'Copy',
      copiedBtn: 'Copied!',
      shareX: 'Share on',
      shareLine: 'Send via LINE',
      toastCopied: 'URL copied to clipboard!',
      tweetText: '[Please Vote] Vote in "{{title}}"! #Votica\n',
    },
    optionInput: {
      title: 'Poll Options',
      countLabel: '{{count}} / {{max}} (2 to 20 options)',
      placeholder: 'Option {{index}} (e.g. Option title)',
      moveUp: 'Move up',
      moveDown: 'Move down',
      minRequired: 'At least 2 options are required',
      remove: 'Remove option',
      addOption: 'Add Option ({{remaining}} remaining)',
    },
    timer: {
      ended: 'Voting Ended (Closed)',
      startsIn: 'Starts in:',
      openRemaining: 'Voting Open (Remaining:',
      days: 'd ',
    },
    roundSelector: {
      label: 'Rounds:',
      roundN: 'Round {{round}}',
      roundTitle: 'Round {{round}}',
      activeBadge: 'Active',
    },
    firebaseModal: {
      title: 'Firebase Connection Settings',
      desc: 'Configure connection for Google Authentication and Firestore database',
      connected: 'Connected to Firebase',
      demoMode: 'Running in Local Demo Mode',
      statusConnected: 'Connected to Firebase',
      statusLocalDemo: 'Running in Local Demo Mode',
      statusConnectedDesc: 'Google Auth and Firestore are active.',
      statusLocalDemoDesc: 'Even without configuration, you can experience all features via browser local storage.',
      connectedDesc: 'Google Auth and Firestore are active.',
      demoDesc: 'Even without configuration, you can experience all features via browser local storage.',
      jsonPasteLabel: 'Paste Firebase console config object (Optional)',
      quickPasteLabel: 'Paste Firebase console config object (Optional)',
      apiKeyLabel: 'API Key (apiKey) *',
      projectIdLabel: 'Project ID (projectId) *',
      authDomainLabel: 'Auth Domain (authDomain)',
      appIdLabel: 'App ID (appId)',
      resetBtn: 'Reset Settings',
      resetConfigBtn: 'Reset Settings',
      localSavedNotice: 'Saved securely in your browser only',
      localStorageNote: 'Saved securely in your browser only',
      saveAndApplyBtn: 'Save and Apply',
      saveApplyBtn: 'Save and Apply',
      toastJsonLoaded: 'Loaded Firebase config JSON',
      toastReqFields: 'API Key and Project ID are required',
      toastRequiredFields: 'API Key and Project ID are required',
      toastSaved: 'Firebase configuration saved. Reloading page...',
      confirmClear: 'Clear saved Firebase settings and return to local demo mode?',
      confirmReset: 'Clear saved Firebase settings and return to local demo mode?',
      toastCleared: 'Firebase settings cleared',
    },
    deleteModal: {
      title: 'Delete this Poll?',
      desc: 'The poll "{{title}}" along with all its rounds, options, and vote records will be permanently deleted. This action cannot be undone.',
      confirmBtn: 'Delete Permanently',
      cancelBtn: 'Cancel',
      toastSuccess: 'Poll deleted successfully',
      toastFailed: 'Failed to delete poll: ',
      notAuthorized: 'You are not authorized to delete this poll',
    },
    schedule: {
      badge: 'Schedule',
      createBadge: 'Create Schedule Adjustment',
      createTitle: 'Create Schedule Adjustment',
      createSubtitle: 'Set up candidate dates and event details to share an attendance sheet. Participants can respond without logging in.',
      tabStandardPoll: 'Standard Poll',
      tabScheduleAdjust: 'Schedule Adjustment',
      createHeaderBtn: 'Schedule',
      homeCreateBtn: 'Create Schedule',
      createNewSchedule: 'Create New Schedule',
      eventInfoTitle: 'Event Information',
      eventTitleLabel: 'Event Name',
      eventTitlePlaceholder: 'e.g. Monthly Team Sync / Welcome Party',
      eventDescLabel: 'Description / Notes (Location, budget, online URL, etc.)',
      eventDescPlaceholder: 'Enter location, budget, details, notes for attendees',
      candidateDatesTitle: 'Candidate Dates',
      candidateCount: 'Candidates: {{count}}',
      candidateTextareaLabel: 'Candidate Dates (One per line)',
      candidateTextareaPlaceholder: '8/25(Mon) 19:00〜\n8/26(Tue) 19:00〜\n8/27(Wed) 20:00〜',
      candidateTextareaHint: '* You can also add dates easily using the picker above (Up to 30 dates)',
      quickAddTitle: 'Calendar & Quick Date Picker',
      quickAddHelp: 'Click to add candidates automatically',
      addCandidateBtn: 'Add Date',
      presetLabel: 'Quick Add',
      preset3Days: 'Next 3 Days',
      preset7Days: 'Next 7 Days',
      presetWeekend: 'This Weekend (Sat/Sun)',
      presetNextWeekdays: 'Next Weekdays (Mon-Fri)',
      settingsTitle: 'Settings & Deadline',
      showAdvanced: 'Show Advanced Settings',
      hideAdvanced: 'Hide Advanced Settings',
      noLoginDesc: 'When checked, participants can respond by simply entering their name without Google login.',
      showAttendanceNamesCheckbox: 'Show participant names and choices (✓?✕) on the matrix table',
      showAttendanceNamesDesc: 'All participants can view each other\'s attendance (recommended for scheduling).',
      publicAttendanceTitle: 'Public attendance sheet to all participants',
      publicAttendanceDesc: 'Anyone with the link can view the attendance sheet and live results in real time.',
      footerNote: 'After creation, share the generated URL with participants via chat, Slack, or email.',
      submitBtn: 'Create Schedule & Get Share Link',
      toastTitleReq: 'Please enter an event name',
      toastMinCandidates: 'Please enter at least 1 candidate date',
      toastMaxCandidates: 'Maximum of 30 candidate dates allowed',
      toastSuccess: 'Schedule adjustment created successfully!',
      defaultRoundTitle: 'Attendance Response',
      scheduleHeaderBadge: 'Schedule Adjustment',
      choicesGuide: 'Select ✓ (Available) / ? (Maybe) / ✕ (Unavailable) for each date',
      votingSectionTitle: 'Submit Your Attendance',
      batchSelectLabel: 'Batch Select',
      allCircle: 'All ✓',
      allTriangle: 'All ?',
      allCross: 'All ✕',
      commentLabel: 'Short Comment',
      optional: 'Optional',
      commentPlaceholder: 'e.g. Will arrive late / Available after 20:00',
      alreadyResponded: 'Responded (Editable)',
      btnSubmitResponse: 'Submit Attendance',
      btnUpdateResponse: 'Update Attendance',
      toastSelectAttendance: 'Please select your attendance for at least 1 date',
      resultsTitle: 'Attendance Results',
      attendanceTableTitle: 'Attendance Matrix Table',
      votersCount: 'Attendees: {{count}}',
      copyTextBtn: 'Copy Text Summary',
      downloadCsvBtn: 'Download CSV',
      toastTextCopied: 'Attendance summary copied to clipboard!',
      toastCsvDownloaded: 'CSV file downloaded successfully!',
      bestCandidateLabel: '👑 Best Candidate Date (Most Attendees)',
      bestCandidateDesc: 'Available (✓): {{circles}} / Total {{total}} voters',
      candidateDateCol: 'Candidate Date',
      scoreCol: 'Score',
      tallyCol: '✓ / ? / ✕',
      commentsRow: 'Comments',
      noVotesYetTitle: 'No responses yet',
      noVotesYetDesc: 'Share the link with participants to collect attendance!',
    },
    theme: {
      sectionTitle: 'Page Design Theme',
      sectionDesc: 'Choose from over 20 unique design themes for your poll or schedule (Default: Classic Indigo).',
      previewTitle: 'Selected Theme Preview',
      selectedBadge: 'Selected',
      catAll: 'All',
      catSimple: 'Simple',
      catBusiness: 'Business',
      catCool: 'Cool & Dark',
      catCute: 'Cute & Pop',
      catNatural: 'Natural & Japanese',
      default: {
        name: 'Classic Indigo',
        desc: 'Sophisticated standard indigo palette with timeless clarity.',
      },
      minimalSlate: {
        name: 'Minimal Slate',
        desc: 'Monochrome and slate gray minimalism with maximum focus.',
      },
      nordicFrost: {
        name: 'Nordic Frost',
        desc: 'Crisp ice blue and cool tones inspired by Scandinavian serenity.',
      },
      warmLatte: {
        name: 'Warm Latte',
        desc: 'Cozy milk tea and sand beige hues for a welcoming mood.',
      },
      corporateNavy: {
        name: 'Corporate Navy',
        desc: 'Authoritative deep navy and slate for professional business decisions.',
      },
      executiveEmerald: {
        name: 'Executive Emerald',
        desc: 'Refined emerald green with rich executive atmosphere.',
      },
      steelGraphite: {
        name: 'Steel Graphite',
        desc: 'Steel gray and sharp accents for analytical and logical meetings.',
      },
      bordeauxWine: {
        name: 'Bordeaux Wine',
        desc: 'Prestigious burgundy and deep wine red for formal occasions.',
      },
      midnightBlack: {
        name: 'Midnight Dark',
        desc: 'Sleek dark mode with deep black and midnight sky accents.',
      },
      cyberNeon: {
        name: 'Cyber Neon',
        desc: 'Glowing neon cyan and magenta for a futuristic cyberpunk vibe.',
      },
      deepSpace: {
        name: 'Deep Space',
        desc: 'Mystical dark violet and cosmic galaxy glow.',
      },
      sunsetGlow: {
        name: 'Sunset Glow',
        desc: 'Passionate orange and dusk warmth with vibrant energy.',
      },
      sakuraPink: {
        name: 'Sakura Pink',
        desc: 'Gentle cherry blossom pink with tender warmth.',
      },
      pastelCandy: {
        name: 'Pastel Candy',
        desc: 'Dreamy pastel lavender and soft sky blue pop.',
      },
      sunnyCitrus: {
        name: 'Sunny Citrus',
        desc: 'Bright and joyful vitamin yellow and sunny citrus cheer.',
      },
      freshMint: {
        name: 'Fresh Mint',
        desc: 'Refreshing mint green and teal with clean vibes.',
      },
      berrySmoothie: {
        name: 'Berry Smoothie',
        desc: 'Sweet and tangy berry pink with playful charm.',
      },
      forestGreen: {
        name: 'Forest Green',
        desc: 'Earthy tones of deep woodland and natural serenity.',
      },
      matchaGreen: {
        name: 'Matcha & Wabi-Sabi',
        desc: 'Traditional Japanese matcha green and ivory elegance.',
      },
      coffeeMocha: {
        name: 'Coffee Mocha',
        desc: 'Rich roast coffee and warm caramel cafe comfort.',
      },
      retroPop: {
        name: 'Retro Pop',
        desc: 'Nostalgic 70s-80s mustard yellow and terracotta retro flair.',
      },
      lavenderGarden: {
        name: 'Lavender Garden',
        desc: 'Soothing herbal lavender purple and lilac calmness.',
      },
    },
  },
} as const;

export type TranslationKeys = typeof translations.ja;

export type NestedKeyOf<ObjectType extends object> = {
  [Key in keyof ObjectType & (string | number)]: ObjectType[Key] extends object
    ? `${Key}.${NestedKeyOf<ObjectType[Key]>}`
    : `${Key}`;
}[keyof ObjectType & (string | number)];

export type TranslationPath = NestedKeyOf<typeof translations.ja>;

/**
 * Helper to interpolate params into string like `{{name}}`
 */
export function interpolate(text: string, params?: Record<string, string | number>): string {
  if (!params) return text;
  return text.replace(/\{\{(\w+)\}\}/g, (_, key) => {
    return params[key] !== undefined ? String(params[key]) : `{{${key}}}`;
  });
}
